export default [
  {
    path: "confirmed-order",
    name: "public-confirmed-order",
    component: () =>
      import("@/modules/public/views/PublicConfirmedOrderView.vue"),
  },
  {
    path: "client-feedback-poll",
    name: "client-feedback-poll",
    component: () =>
      import("@/modules/public/views/PublicClientFeedbackPoll.vue"),
  },
  {
    path: "client-declined-order-poll",
    name: "client-declined-order-poll",
    component: () =>
      import("@/modules/public/views/PublicClientDeclinedOrderPoll.vue"),
  },
  {
    path: "client-reschedule-visit",
    name: "client-reschedule-visit",
    component: () =>
      import("@/modules/public/views/PublicClientRescheduleVisit.vue"),
  },
  {
    path: "expired-link",
    name: "expired-link",
    component: () => import("@/modules/public/views/PublicExpiredLink.vue"),
  },
];
